import React, { Component } from 'react'
import { StyleSheet, css } from 'aphrodite'
import { SvgIcon } from 'inno-components'
import { navigate } from 'gatsby'
import { withNamespaces } from 'react-i18next'
import i18next from '../config/i18n/context'
import Link from '../components/Link'
import pagesInfos from '../config/i18n/pagesInfos'

const translateKeyframes = {
  '0%': {
    transform: 'translateX(0)'
  },

  '50%': {
    transform: 'translateX(100px)'
  },

  '100%': {
    transform: 'translateX(0)'
  }
}

const opacityKeyframes = {
  from: {
    opacity: 0
  },

  to: {
    opacity: 1
  }
}

const styles = StyleSheet.create({
  zippyHeader: {
    animationName: [translateKeyframes, opacityKeyframes],
    animationDuration: '3s, 1200ms',
    animationIterationCount: 'infinite'
  },
  logistique: {
    transition: 'all 0.3s',
    cursor: 'pointer'
  },
  logistiqueHover: {
    animation: 'x 1s'
    // animationName: Radium.keyframes(fadeIn, "fadeIn")
    // transform: 'translateX(-5px)'
  },
  composition: {
    transition: 'all 0.3s',
    cursor: 'pointer'
  },
  compositionHover: {
    animation: 'x 1s'
    // animationName: Radium.keyframes(fadeIn, "fadeIn")
    // transform: 'translate(-1.5px, -4px)'
  }
})

class Pie extends Component {
  constructor(props) {
    super(props)
    this.state = {
      composition: styles.composition,
      accredidations: styles.composition,
      dureeDeVie: styles.composition,
      regleUtilisation: styles.composition,
      garantieEtProcessus: styles.composition
    }
  }

  componentDidMount() {}

  onMouseAction = (name, style) => {
    this.setState({
      [name]: style
    })
  }

  render() {
    const { t } = this.props
    const language = i18next.language || window.localStorage.i18nextLng

    let CompositionText
    let AccreditationsText
    let DureeDeVieText
    let RegleDUtilisationText
    let GarantieEtProcessusText
    if (language === 'fr') {
      CompositionText = (
        <tspan
          x="-9.989"
          y="-0.5"
          fontFamily="Raleway"
          fontWeight="bold"
          fontSize="3"
          fill="#FFFFFF"
        >
          {t('pie.composition.0').toUpperCase()}
        </tspan>
      )
      AccreditationsText = (
        <tspan
          x="-12.203"
          y="-0.5"
          fontFamily="Raleway"
          fontWeight="bold"
          fontSize="3"
          fill="#FFFFFF"
        >
          {t('pie.accredidations.0').toUpperCase()}
        </tspan>
      )
      DureeDeVieText = (
        <text transform="matrix(1, 0, 0, 1, 69.126, 64.1)">
          <tspan
            x="-4.815"
            y="-3.5"
            fontFamily="Raleway"
            fontWeight="bold"
            fontSize="3"
            fill="#FFFFFF"
          >
            {t('pie.duree-de-vie.0').toUpperCase()}
          </tspan>
          <tspan
            x="-1.904"
            y="0.5"
            fontFamily="Raleway"
            fontWeight="bold"
            fontSize="3"
            fill="#FFFFFF"
          >
            {t('pie.duree-de-vie.1').toUpperCase()}
          </tspan>
          <tspan
            x="-2.167"
            y="4.5"
            fontFamily="Raleway"
            fontWeight="bold"
            fontSize="3"
            fill="#FFFFFF"
          >
            {t('pie.duree-de-vie.2').toUpperCase()}
          </tspan>
        </text>
      )
      RegleDUtilisationText = (
        <text transform="matrix(1, 0, 0, 1, 43.074, 72.4)">
          <tspan
            x="-4.684"
            y="-5.5"
            fontFamily="Raleway"
            fontWeight="bold"
            fontSize="3"
            fill="#FFFFFF"
          >
            {t('pie.regle-d-utilisation.0').toUpperCase()}
          </tspan>
          <tspan
            x="-10.282"
            y="-1.5"
            fontFamily="Raleway"
            fontWeight="bold"
            fontSize="3"
            fill="#FFFFFF"
          >
            {t('pie.regle-d-utilisation.1').toUpperCase()}
          </tspan>
          <tspan
            x="-2.257"
            y="2.5"
            fontFamily="Raleway"
            fontWeight="bold"
            fontSize="3"
            fill="#FFFFFF"
          >
            {t('pie.regle-d-utilisation.2').toUpperCase()}
          </tspan>
          <tspan
            x="-9.201"
            y="6.5"
            fontFamily="Raleway"
            fontWeight="bold"
            fontSize="3"
            fill="#FFFFFF"
          >
            {t('pie.regle-d-utilisation.3').toUpperCase()}
          </tspan>
        </text>
      )
      GarantieEtProcessusText = (
        <text transform="matrix(1, 0, 0, 1, 27.126, 49.1)">
          <tspan
            x="-7.081"
            y="-5.5"
            fontFamily="Raleway"
            fontWeight="bold"
            fontSize="3"
            fill="#FFFFFF"
          >
            {t('pie.garantie-et-processus.0').toUpperCase()}
          </tspan>
          <tspan
            x="-1.772"
            y="-1.5"
            fontFamily="Raleway"
            fontWeight="bold"
            fontSize="3"
            fill="#FFFFFF"
          >
            {t('pie.garantie-et-processus.1').toUpperCase()}
          </tspan>
          <tspan
            x="-8.676"
            y="2.5"
            fontFamily="Raleway"
            fontWeight="bold"
            fontSize="3"
            fill="#FFFFFF"
          >
            {t('pie.garantie-et-processus.2').toUpperCase()}
          </tspan>
          <tspan
            x="-11.011"
            y="6.5"
            fontFamily="Raleway"
            fontWeight="bold"
            fontSize="3"
            fill="#FFFFFF"
          >
            {`${t('pie.garantie-et-processus.3').toUpperCase()} ${t(
              'pie.garantie-et-processus.4'
            ).toUpperCase()}`}
          </tspan>
        </text>
      )
    } else if (language === 'en') {
      CompositionText = (
        <tspan
          x="-9.989"
          y="-0.5"
          fontFamily="Raleway"
          fontWeight="bold"
          fontSize="3"
          fill="#FFFFFF"
        >
          {t('pie.composition.0').toUpperCase()}
        </tspan>
      )
      AccreditationsText = (
        <tspan
          x="-12.203"
          y="-0.5"
          fontFamily="Raleway"
          fontWeight="bold"
          fontSize="3"
          fill="#FFFFFF"
        >
          {t('pie.accredidations.0').toUpperCase()}
        </tspan>
      )
      DureeDeVieText = (
        <text transform="matrix(1, 0, 0, 1, 69.126, 64.1)">
          <tspan x="-5" y="0.5" fontFamily="Raleway" fontWeight="bold" fontSize="3" fill="#FFFFFF">
            {t('pie.duree-de-vie.0').toUpperCase()}
          </tspan>
        </text>
      )
      RegleDUtilisationText = (
        <text transform="matrix(1, 0, 0, 1, 43.074, 72.4)">
          <tspan
            x="-4.684"
            y="-5.5"
            fontFamily="Raleway"
            fontWeight="bold"
            fontSize="3"
            fill="#FFFFFF"
          >
            {t('pie.regle-d-utilisation.0').toUpperCase()}
          </tspan>
          <tspan x="-3" y="-1.5" fontFamily="Raleway" fontWeight="bold" fontSize="3" fill="#FFFFFF">
            {t('pie.regle-d-utilisation.1').toUpperCase()}
          </tspan>
          <tspan x="-10" y="2.5" fontFamily="Raleway" fontWeight="bold" fontSize="3" fill="#FFFFFF">
            {t('pie.regle-d-utilisation.2').toUpperCase()}
          </tspan>
          <tspan x="-10" y="6.5" fontFamily="Raleway" fontWeight="bold" fontSize="3" fill="#FFFFFF">
            {t('pie.regle-d-utilisation.3').toUpperCase()}
          </tspan>
        </text>
      )
      GarantieEtProcessusText = (
        <text transform="matrix(1, 0, 0, 1, 27.126, 49.1)">
          <tspan
            x="-12"
            y="-1.5"
            fontFamily="Raleway"
            fontWeight="bold"
            fontSize="3"
            fill="#FFFFFF"
          >
            {t('pie.garantie-et-processus.0').toUpperCase()}
          </tspan>
          <tspan
            x="-8.676"
            y="2.5"
            fontFamily="Raleway"
            fontWeight="bold"
            fontSize="3"
            fill="#FFFFFF"
          >
            {t('pie.garantie-et-processus.1').toUpperCase()}
          </tspan>
          <tspan x="-12" y="6.5" fontFamily="Raleway" fontWeight="bold" fontSize="3" fill="#FFFFFF">
            {t('pie.garantie-et-processus.2').toUpperCase()}
          </tspan>
        </text>
      )
    } else {
      CompositionText = (
        <tspan x="-13" y="-0.5" fontFamily="Raleway" fontWeight="bold" fontSize="3" fill="#FFFFFF">
          {t('pie.composition.0').toUpperCase()}
        </tspan>
      )
      AccreditationsText = (
        <tspan
          x="-10.203"
          y="-0.5"
          fontFamily="Raleway"
          fontWeight="bold"
          fontSize="3"
          fill="#FFFFFF"
        >
          {t('pie.accredidations.0').toUpperCase()}
        </tspan>
      )
      DureeDeVieText = (
        <text transform="matrix(1, 0, 0, 1, 69.126, 64.1)">
          <tspan x="-10" y="0.5" fontFamily="Raleway" fontWeight="bold" fontSize="3" fill="#FFFFFF">
            {t('pie.duree-de-vie.0').toUpperCase()}
          </tspan>
        </text>
      )
      RegleDUtilisationText = (
        <text transform="matrix(1, 0, 0, 1, 43.074, 72.4)">
          <tspan
            x="-4.684"
            y="-5.5"
            fontFamily="Raleway"
            fontWeight="bold"
            fontSize="3"
            fill="#FFFFFF"
          >
            {t('pie.regle-d-utilisation.0').toUpperCase()}
          </tspan>
          <tspan x="-3" y="-1.5" fontFamily="Raleway" fontWeight="bold" fontSize="3" fill="#FFFFFF">
            {t('pie.regle-d-utilisation.1').toUpperCase()}
          </tspan>
          <tspan x="-6" y="2.5" fontFamily="Raleway" fontWeight="bold" fontSize="3" fill="#FFFFFF">
            {t('pie.regle-d-utilisation.2').toUpperCase()}
          </tspan>
          <tspan x="-12" y="6.5" fontFamily="Raleway" fontWeight="bold" fontSize="3" fill="#FFFFFF">
            {`${t('pie.regle-d-utilisation.3').toUpperCase()} ${t(
              'pie.regle-d-utilisation.4'
            ).toUpperCase()}`}
          </tspan>
        </text>
      )
      GarantieEtProcessusText = (
        <text transform="matrix(1, 0, 0, 1, 27.126, 49.1)">
          <tspan
            x="-12"
            y="-1.5"
            fontFamily="Raleway"
            fontWeight="bold"
            fontSize="3"
            fill="#FFFFFF"
          >
            {t('pie.garantie-et-processus.0').toUpperCase()}
          </tspan>
          <tspan x="-6" y="2.5" fontFamily="Raleway" fontWeight="bold" fontSize="3" fill="#FFFFFF">
            {t('pie.garantie-et-processus.1').toUpperCase()}
          </tspan>
          <tspan x="-17" y="6.5" fontFamily="Raleway" fontWeight="bold" fontSize="3" fill="#FFFFFF">
            {t('pie.garantie-et-processus.2').toUpperCase()}
          </tspan>
        </text>
      )
    }
    return (
      <SvgIcon viewBox="0, 0, 100, 100" className={this.props.className}>
        <g id="Layer_1">
          <g>
            <g
              id="Garantie"
              style={this.state.garantieEtProcessus}
              cursor="pointer"
              onClick={() => navigate(pagesInfos.ComponentMethodeRaypathGarantieEtProcessus.path[language])
              }
            >
              <path
                d="M5.089,50.044 C5.098,58.352 7.42,66.661 12.053,73.986 C12.6,74.85 13.758,75.082 14.585,74.481 L26.666,65.691 L26.66,65.69 L5.089,50.044"
                fill="#33973D"
              />
              <path
                d="M26.66,65.69 L26.666,65.691 L47.413,50.596 C47.815,50.304 47.814,49.706 47.413,49.413 L26.648,34.348 L26.639,34.348 L5.088,50.033 C5.088,50.037 5.088,50.039 5.088,50.044 L26.66,65.69"
                fill="#33973D"
              />
              <path
                d="M26.648,34.348 L14.546,25.567 C13.722,24.97 12.562,25.196 12.02,26.057 C7.39,33.392 5.08,41.713 5.088,50.033 L26.639,34.348 L26.648,34.348"
                fill="#33973D"
              />
              <path
                d="M12.386,33.517 C12.517,33.49 12.602,33.362 12.575,33.232 C12.548,33.1 12.42,33.016 12.289,33.043 L11.85,33.132 C11.719,33.159 11.635,33.286 11.661,33.417 C11.688,33.549 11.816,33.633 11.947,33.606 L12.386,33.517 z M12.28,32.389 C12.411,32.413 12.537,32.325 12.561,32.193 C12.585,32.062 12.498,31.936 12.366,31.912 L11.925,31.833 C11.794,31.808 11.668,31.896 11.644,32.028 C11.62,32.159 11.707,32.285 11.839,32.309 L12.28,32.389 z M12.696,31.417 C12.796,31.506 12.949,31.497 13.038,31.397 C13.127,31.296 13.118,31.144 13.018,31.055 L12.683,30.758 C12.583,30.669 12.43,30.678 12.341,30.778 C12.252,30.879 12.261,31.031 12.362,31.12 L12.696,31.417 z M13.566,30.731 C13.63,30.849 13.777,30.892 13.894,30.829 C14.012,30.765 14.055,30.618 13.991,30.501 L13.778,30.107 C13.714,29.989 13.568,29.946 13.45,30.01 C13.333,30.073 13.289,30.22 13.353,30.338 L13.566,30.731 z M17.963,33.606 C18.093,33.633 18.221,33.549 18.248,33.417 C18.275,33.286 18.19,33.159 18.059,33.132 L17.62,33.043 C17.489,33.016 17.361,33.1 17.335,33.232 C17.308,33.362 17.393,33.49 17.524,33.517 L17.963,33.606 z M18.071,32.309 C18.202,32.285 18.289,32.159 18.265,32.028 C18.242,31.896 18.115,31.808 17.984,31.833 L17.543,31.912 C17.412,31.936 17.325,32.062 17.348,32.193 C17.372,32.325 17.498,32.413 17.63,32.389 L18.071,32.309 z M17.548,31.12 C17.648,31.031 17.657,30.879 17.568,30.778 C17.48,30.678 17.326,30.669 17.227,30.758 L16.892,31.055 C16.792,31.144 16.783,31.296 16.871,31.397 C16.961,31.497 17.113,31.506 17.214,31.417 L17.548,31.12 z M16.557,30.338 C16.621,30.22 16.577,30.073 16.46,30.01 C16.342,29.946 16.195,29.989 16.131,30.107 L15.918,30.501 C15.854,30.618 15.898,30.765 16.016,30.829 C16.133,30.892 16.28,30.849 16.344,30.731 L16.557,30.338 z M15.213,29.942 C15.213,29.808 15.104,29.7 14.97,29.7 C14.837,29.7 14.729,29.808 14.729,29.942 L14.729,30.389 C14.729,30.523 14.837,30.631 14.97,30.631 C15.104,30.631 15.213,30.523 15.213,30.389 L15.213,29.942 z M17.174,32.24 C16.994,31.532 16.148,30.766 14.97,30.765 C13.793,30.766 12.947,31.532 12.767,32.24 C12.63,32.779 12.755,33.289 13.014,33.786 C13.247,34.237 13.489,34.606 13.69,35.066 C13.8,35.318 13.843,35.669 13.902,35.934 C13.949,36.145 14.029,36.216 14.285,36.219 C14.339,36.219 14.392,36.219 14.446,36.219 L14.446,33.622 L14.047,33.622 C13.87,33.622 13.705,33.553 13.58,33.429 C13.456,33.304 13.387,33.139 13.387,32.962 C13.387,32.786 13.456,32.621 13.58,32.496 C13.705,32.371 13.87,32.303 14.047,32.303 C14.408,32.303 14.702,32.594 14.707,32.954 L14.707,33.362 L15.236,33.362 L15.236,32.954 C15.238,32.781 15.306,32.619 15.429,32.496 C15.553,32.371 15.719,32.303 15.895,32.303 C16.071,32.303 16.237,32.371 16.361,32.496 C16.486,32.621 16.555,32.786 16.555,32.962 C16.555,33.139 16.486,33.304 16.361,33.429 C16.237,33.553 16.071,33.622 15.895,33.622 L15.495,33.622 L15.495,36.219 C15.549,36.219 15.603,36.219 15.656,36.219 C15.912,36.216 15.993,36.145 16.04,35.934 C16.099,35.669 16.142,35.318 16.251,35.066 C16.452,34.606 16.695,34.237 16.928,33.786 C17.186,33.289 17.311,32.779 17.174,32.24 z M16.294,32.962 C16.294,32.742 16.115,32.563 15.895,32.563 C15.675,32.563 15.495,32.742 15.495,32.962 L15.495,33.362 L15.895,33.362 C16.115,33.362 16.294,33.183 16.294,32.962 z M14.047,32.563 C13.826,32.563 13.647,32.742 13.647,32.962 C13.647,33.183 13.826,33.362 14.047,33.362 L14.446,33.362 L14.446,32.962 C14.446,32.742 14.267,32.563 14.047,32.563 z M15.236,33.622 L14.707,33.622 L14.707,36.219 C14.79,36.219 14.874,36.219 14.958,36.219 C14.958,36.216 14.958,36.221 14.958,36.219 C14.962,36.219 14.966,36.219 14.97,36.219 C14.975,36.219 14.979,36.219 14.983,36.219 C14.983,36.221 14.983,36.216 14.983,36.219 C15.067,36.219 15.152,36.219 15.236,36.219 L15.236,33.622 z M16.087,36.66 C16.087,36.507 15.963,36.383 15.81,36.383 L14.131,36.383 C13.979,36.383 13.854,36.507 13.854,36.66 C13.854,36.813 13.979,36.937 14.131,36.937 L15.81,36.937 C15.963,36.937 16.087,36.813 16.087,36.66 z M16.087,37.384 C16.087,37.537 15.963,37.661 15.81,37.661 L14.131,37.661 C13.979,37.661 13.854,37.537 13.854,37.384 C13.854,37.231 13.979,37.107 14.131,37.107 L15.81,37.107 C15.963,37.107 16.087,37.231 16.087,37.384"
                fill="#FFFFFF"
              />
              <g className="topBotomBordersOut">{GarantieEtProcessusText}</g>
            </g>
            <g
              id="Composition"
              style={this.state.composition}
              cursor="pointer"
              onClick={() => navigate(pagesInfos.ComponentMethodeRaypathComposition.path[language])}
            >
              <path
                d="M15.818,23.829 L27.912,32.605 L36.129,7.245 C28.228,9.822 21.042,14.598 15.505,21.269 C14.852,22.056 14.99,23.229 15.818,23.829"
                fill="#E1E8DD"
              />
              <path
                d="M27.912,32.605 L48.677,47.671 C49.079,47.963 49.648,47.777 49.802,47.305 L57.713,22.9 L36.129,7.245 L27.912,32.605"
                fill="#D4DAD0"
              />
              <path
                d="M61.069,6.424 C52.663,4.29 44.038,4.666 36.129,7.245 L57.713,22.9 L62.325,8.677 C62.639,7.705 62.06,6.675 61.069,6.424"
                fill="#C6CDC3"
              />
              <path
                d="M56.034,12.409 C56.132,12.288 56.205,12.106 55.99,11.932 L55.822,11.776 C54.982,11.049 53.992,10.215 53.772,10.075 C53.666,10.096 53.39,10.184 53.172,10.261 L53.162,10.265 C53.148,10.268 52.812,10.366 52.509,10.366 C52.333,10.366 52.198,10.335 52.096,10.27 C51.918,10.156 51.896,10.008 51.899,9.931 C51.906,9.74 52.067,9.579 52.184,9.509 L50.488,9.298 L50.314,11.745 C50.452,11.6 50.59,11.568 50.687,11.568 C50.801,11.568 50.917,11.613 51.021,11.698 C51.184,11.831 51.261,12.008 51.235,12.189 C51.377,12.166 51.512,12.212 51.636,12.313 C51.799,12.447 51.876,12.623 51.851,12.804 C51.991,12.781 52.127,12.827 52.251,12.928 C52.392,13.044 52.469,13.196 52.469,13.354 C52.625,13.308 52.787,13.35 52.929,13.466 C53.125,13.627 53.194,13.847 53.118,14.061 L53.264,14.18 C53.276,14.189 53.287,14.198 53.298,14.205 L53.304,14.209 C53.365,14.25 53.425,14.271 53.482,14.271 C53.588,14.271 53.667,14.201 53.714,14.143 C53.816,14.018 53.878,13.919 53.75,13.788 L53.739,13.777 L52.983,13.137 C52.959,13.116 52.944,13.087 52.942,13.055 C52.939,13.022 52.949,12.991 52.97,12.966 C53.012,12.917 53.091,12.91 53.141,12.952 L54.128,13.789 C54.179,13.819 54.237,13.836 54.295,13.836 C54.394,13.836 54.491,13.786 54.565,13.695 C54.626,13.619 54.654,13.537 54.647,13.457 C54.638,13.371 54.588,13.288 54.499,13.216 L54.382,13.121 L54.383,13.119 L53.834,12.673 C53.81,12.653 53.794,12.624 53.79,12.592 C53.787,12.56 53.796,12.528 53.817,12.503 C53.858,12.453 53.937,12.444 53.988,12.485 L54.891,13.22 C54.957,13.273 55.027,13.301 55.101,13.301 C55.207,13.301 55.317,13.241 55.402,13.136 C55.468,13.055 55.498,12.974 55.492,12.896 C55.485,12.811 55.436,12.732 55.347,12.659 L55.082,12.443 L55.083,12.442 L54.612,12.06 C54.56,12.018 54.552,11.941 54.594,11.889 C54.635,11.839 54.715,11.831 54.765,11.871 L55.532,12.495 C55.695,12.627 55.888,12.589 56.034,12.409 z M50.482,12.886 L50.946,12.339 C51.142,12.099 50.951,11.912 50.888,11.86 C50.733,11.732 50.574,11.752 50.436,11.922 L50.284,12.116 L50.285,12.117 L50.261,12.148 L50.049,12.392 C49.971,12.482 49.935,12.57 49.942,12.653 C49.951,12.745 50.01,12.805 50.045,12.832 C50.125,12.895 50.213,12.966 50.309,12.966 C50.368,12.966 50.424,12.94 50.482,12.886 z M50.582,13.088 C50.513,13.174 50.485,13.263 50.501,13.352 C50.516,13.43 50.564,13.505 50.641,13.567 C50.796,13.695 50.955,13.675 51.094,13.505 L51.561,12.954 C51.631,12.869 51.658,12.78 51.643,12.691 C51.628,12.612 51.58,12.537 51.503,12.475 C51.348,12.347 51.189,12.368 51.051,12.537 L50.818,12.814 L50.819,12.814 L50.795,12.844 L50.582,13.088 z M51.197,13.704 C51.077,13.851 51.107,13.982 51.3,14.139 C51.455,14.266 51.614,14.246 51.753,14.077 L52.176,13.57 C52.373,13.329 52.182,13.141 52.119,13.09 C51.963,12.963 51.804,12.983 51.666,13.152 L51.434,13.429 L51.434,13.429 L51.41,13.46 L51.197,13.704 z M52.936,13.844 C52.922,13.765 52.874,13.69 52.797,13.627 C52.641,13.5 52.482,13.521 52.344,13.69 L52.177,13.892 L52.156,13.919 L52.012,14.095 C51.815,14.336 52.006,14.524 52.069,14.576 C52.136,14.631 52.204,14.659 52.271,14.659 C52.358,14.659 52.443,14.609 52.522,14.513 L52.766,14.214 L52.854,14.108 C52.924,14.021 52.952,13.932 52.936,13.844 z M49.269,11.671 C49.264,11.733 49.284,11.792 49.324,11.838 C49.364,11.885 49.42,11.914 49.482,11.918 L49.85,11.946 C49.977,11.957 50.087,11.859 50.097,11.733 L50.281,9.292 C50.285,9.231 50.266,9.171 50.226,9.124 C50.186,9.078 50.129,9.05 50.068,9.045 L49.701,9.017 C49.694,9.017 49.688,9.017 49.683,9.017 C49.563,9.017 49.462,9.11 49.453,9.23 L49.269,11.671 z M57.103,8.691 C57.074,8.691 57.046,8.697 57.018,8.707 L56.675,8.843 C56.618,8.866 56.573,8.909 56.549,8.966 C56.524,9.023 56.523,9.085 56.545,9.143 L57.406,11.315 C57.451,11.431 57.589,11.491 57.706,11.445 L58.048,11.309 C58.106,11.286 58.151,11.243 58.175,11.186 C58.2,11.13 58.2,11.067 58.178,11.01 L57.318,8.837 C57.283,8.748 57.198,8.691 57.103,8.691 z M56.374,9.271 L57.198,11.339 L56.163,11.785 C55.62,11.314 53.941,9.864 53.799,9.855 C53.678,9.855 53.159,10.037 53.102,10.058 C53.098,10.058 52.783,10.15 52.509,10.15 C52.377,10.15 52.277,10.129 52.212,10.088 C52.145,10.045 52.112,9.995 52.114,9.939 C52.118,9.832 52.241,9.723 52.304,9.689 C52.746,9.453 53.924,9.009 54.044,8.996 C54.049,8.995 54.056,8.995 54.066,8.995 C54.35,8.995 56.155,9.241 56.374,9.271"
                fill="#FFFFFF"
              />
              <text transform="matrix(1, 0, 0, 1, 43.074, 29.6)">{CompositionText}</text>
            </g>
            <g
              id="Accreditations"
              style={this.state.accredidations}
              cursor="pointer"
              onClick={() => navigate(pagesInfos.ComponentMethodeRaypathAccreditation.path[language])
              }
            >
              <path
                d="M59.764,23.572 L59.759,23.574 L51.85,47.969 C51.698,48.441 52.049,48.925 52.546,48.925 L78.205,48.908 L86.421,23.55 L59.764,23.572"
                fill="#2A3D6C"
              />
              <path
                d="M78.205,48.908 L93.152,48.899 C94.175,48.898 94.975,48.029 94.908,47.009 C94.34,38.358 91.319,30.274 86.426,23.551 L86.421,23.55 L78.205,48.908"
                fill="#2A3D6C"
              />
              <path
                d="M86.426,23.551 C86.426,23.55 86.424,23.548 86.423,23.546 L86.421,23.55 L86.426,23.551"
                fill="#FFA337"
              />
              <path
                d="M59.764,23.572 L86.421,23.55 L86.423,23.546 C81.53,16.826 74.766,11.467 66.709,8.262 C65.759,7.885 64.686,8.378 64.37,9.351 L59.759,23.574 L59.764,23.572"
                fill="#2A3D6C"
              />
              <path
                d="M92.057,45.018 L91.272,44.564 L91.272,44.846 L84.967,44.846 L84.967,39.801 L85.253,39.801 L84.795,39.008 L84.337,39.801 L84.624,39.801 L84.624,45.189 L91.272,45.189 L91.272,45.471 L92.057,45.018 z M85.493,41.599 C87.14,41.298 88.685,40.707 90.074,39.876 L90.201,40.118 L90.689,39.349 L89.778,39.311 L89.915,39.573 C88.558,40.386 87.047,40.966 85.437,41.261 L85.493,41.599 z M90.262,40.581 C90.122,40.581 90.008,40.694 90.008,40.834 L90.008,44.273 C90.008,44.413 90.122,44.526 90.262,44.526 L90.686,44.526 C90.826,44.526 90.939,44.413 90.939,44.273 L90.939,40.834 C90.939,40.694 90.826,40.581 90.686,40.581 L90.262,40.581 z M88.715,41.128 C88.575,41.128 88.461,41.241 88.461,41.381 L88.461,44.273 C88.461,44.413 88.575,44.526 88.715,44.526 L89.14,44.526 C89.28,44.526 89.393,44.413 89.393,44.273 L89.393,41.381 C89.393,41.241 89.28,41.128 89.14,41.128 L88.715,41.128 z M87.172,41.658 C87.032,41.658 86.918,41.772 86.918,41.911 L86.918,44.273 C86.918,44.413 87.032,44.526 87.172,44.526 L87.596,44.526 C87.736,44.526 87.85,44.413 87.85,44.273 L87.85,41.911 C87.85,41.772 87.736,41.658 87.596,41.658 L87.172,41.658 z M85.376,44.273 L85.376,42.53 C85.376,42.39 85.489,42.276 85.629,42.276 L86.053,42.276 C86.193,42.276 86.307,42.39 86.307,42.53 L86.307,44.273 C86.307,44.413 86.193,44.526 86.053,44.526 L85.629,44.526 C85.489,44.526 85.376,44.413 85.376,44.273"
                fill="#FFFFFF"
              />
              <text transform="matrix(1, 0, 0, 1, 69.126, 36.6)">{AccreditationsText}</text>
            </g>
            <g
              id="DureeDeVie"
              style={this.state.dureeDeVie}
              cursor="pointer"
              onClick={() => navigate(pagesInfos.ComponentMethodeRaypathDureeDeVie.path[language])}
            >
              <path
                d="M78.197,51.074 L86.455,76.417 C91.336,69.687 94.345,61.596 94.903,52.941 C94.969,51.921 94.167,51.052 93.145,51.053 L78.188,51.062 L78.197,51.074"
                fill="#898989"
              />
              <path
                d="M78.188,51.062 L52.547,51.079 C52.051,51.079 51.699,51.564 51.853,52.035 L59.801,76.442 L86.453,76.419 C86.454,76.419 86.454,76.418 86.455,76.417 L78.197,51.074 L78.188,51.062"
                fill="#767676"
              />
              <path
                d="M66.767,91.732 C74.817,88.519 81.571,83.15 86.453,76.419 L59.801,76.442 L64.426,90.647 C64.743,91.619 65.817,92.111 66.767,91.732"
                fill="#666666"
              />
              <path
                d="M73.069,84.566 C73.069,83.806 72.478,83.188 71.291,82.9 C71.157,82.872 70.496,82.703 70.37,82.668 C69.449,82.436 69.189,82.288 69.189,82.05 C69.189,81.782 69.526,81.487 70.454,81.487 C71.115,81.487 71.776,81.981 71.776,81.981 C72.036,82.154 72.193,82.144 72.41,81.937 C72.41,81.937 72.691,81.7 72.691,81.477 C72.691,81.14 71.895,80.657 71.049,80.488 L71.049,79.899 C71.049,79.748 70.9,79.626 70.714,79.626 L70.328,79.626 C70.142,79.626 69.992,79.748 69.992,79.899 L69.992,80.45 C68.67,80.581 67.973,81.264 67.973,82.078 C67.973,83.041 68.88,83.42 69.892,83.68 C70.025,83.715 70.819,83.912 70.946,83.94 C71.691,84.122 71.853,84.403 71.853,84.586 C71.853,84.902 71.515,85.198 70.581,85.198 C69.92,85.198 69.02,84.645 69.02,84.645 C68.773,84.487 68.537,84.527 68.33,84.77 C68.33,84.77 68.164,84.971 68.164,85.205 C68.164,85.558 69.103,86.025 69.992,86.201 L69.992,86.79 C69.992,86.941 70.142,87.063 70.328,87.063 L70.714,87.063 C70.9,87.063 71.049,86.941 71.049,86.79 L71.049,86.234 C72.446,86.09 73.069,85.353 73.069,84.566"
                fill="#FFFFFF"
              />
              {DureeDeVieText}
            </g>
            <g
              id="RegleUtilisation"
              style={this.state.regleUtilisation}
              cursor="pointer"
              onClick={() => navigate(pagesInfos.ComponentMethodeRaypathRegleDutilisation.path[language])
              }
            >
              <path
                d="M15.535,78.789 C21.078,85.452 28.272,90.217 36.181,92.779 L27.924,67.439 L15.844,76.228 C15.017,76.829 14.881,78.004 15.535,78.789"
                fill="#37C7DE"
              />
              <path
                d="M27.924,67.439 L36.181,92.779 C36.187,92.781 36.188,92.782 36.193,92.783 L57.738,77.103 L57.746,77.09 L49.805,52.703 C49.651,52.23 49.081,52.046 48.68,52.338 L27.924,67.439"
                fill="#3BD3EB"
              />
              <path
                d="M36.193,92.783 C44.104,95.344 52.728,95.704 61.131,93.558 C62.118,93.306 62.69,92.273 62.375,91.305 L57.746,77.09 L57.738,77.103 L36.193,92.783"
                fill="#3FDDF6"
              />
              <path
                d="M21.605,80.36 C21.566,80.136 21.651,79.902 21.837,79.717 C21.911,79.642 21.989,79.572 22.074,79.505 C22.024,79.486 21.976,79.467 21.926,79.448 C21.675,79.35 21.6,79.091 21.79,78.905 C22.171,78.53 22.314,78.062 22.294,77.548 C22.273,77.007 21.956,76.72 21.458,76.597 C21.351,76.571 21.246,76.558 21.144,76.557 C21.042,76.558 20.936,76.571 20.83,76.597 C20.332,76.72 20.015,77.007 19.994,77.548 C19.974,78.062 20.117,78.521 20.498,78.905 C20.685,79.093 20.613,79.35 20.361,79.448 C20.226,79.501 20.089,79.551 19.957,79.612 C19.66,79.75 19.38,79.912 19.147,80.145 C18.936,80.356 18.941,80.661 19.315,80.837 C19.439,80.897 19.574,80.94 19.708,80.972 C20.143,81.075 20.588,81.093 21.144,81.104 C21.588,81.095 21.961,81.081 22.315,81.024 C22.244,80.998 22.175,80.97 22.111,80.94 C21.826,80.805 21.646,80.599 21.605,80.36 z M30.092,80.238 C29.882,80.027 29.629,79.882 29.361,79.756 C29.242,79.701 29.118,79.656 28.996,79.609 C28.768,79.519 28.702,79.286 28.873,79.118 C29.216,78.779 29.346,78.357 29.328,77.893 C29.309,77.405 29.023,77.145 28.573,77.034 C28.476,77.01 28.381,76.999 28.289,76.998 C28.197,76.999 28.102,77.01 28.005,77.034 C27.555,77.145 27.269,77.405 27.25,77.893 C27.232,78.357 27.362,78.772 27.706,79.118 C27.875,79.288 27.81,79.519 27.583,79.609 C27.573,79.612 27.564,79.616 27.555,79.619 C27.59,79.651 27.625,79.683 27.658,79.717 C27.816,79.875 27.892,80.13 27.851,80.366 C27.808,80.613 27.642,80.818 27.384,80.94 C27.32,80.97 27.252,80.997 27.181,81.023 C27.516,81.082 27.867,81.096 28.289,81.104 C28.791,81.094 29.193,81.078 29.585,80.985 C29.707,80.956 29.829,80.917 29.941,80.864 C30.279,80.704 30.221,80.367 30.092,80.238 z M27.123,80.758 C26.962,80.835 26.788,80.891 26.613,80.932 C26.047,81.066 25.47,81.09 24.749,81.104 C24.027,81.09 23.45,81.066 22.884,80.932 C22.71,80.891 22.535,80.835 22.374,80.758 C21.888,80.529 21.881,80.132 22.156,79.858 C22.459,79.556 22.822,79.346 23.208,79.167 C23.379,79.088 23.557,79.022 23.733,78.954 C24.059,78.826 24.153,78.493 23.909,78.249 C23.415,77.75 23.23,77.155 23.255,76.487 C23.282,75.785 23.694,75.412 24.34,75.252 C24.48,75.219 24.616,75.201 24.749,75.2 C24.881,75.201 25.017,75.219 25.157,75.252 C25.804,75.412 26.214,75.785 26.242,76.487 C26.267,77.155 26.082,77.761 25.587,78.249 C25.342,78.491 25.438,78.826 25.764,78.954 C25.94,79.022 26.118,79.088 26.289,79.167 C26.676,79.346 27.039,79.556 27.341,79.858 C27.526,80.044 27.609,80.529 27.123,80.758"
                fill="#FFFFFF"
              />
              {RegleDUtilisationText}
            </g>
          </g>
        </g>
      </SvgIcon>
    )
  }
}

export default withNamespaces('methode-raypath')(Pie)
